<template>
  <div class="language-switch" :title="$t('language.select_language')">
    <span class="language-switch__label">{{ $t('language.select_language') }}</span>
    <div class="language-switch__track">
      <button
        v-for="language in languages"
        :key="language.code"
        type="button"
        class="language-switch__option"
        :class="{ 'language-switch__option--active': currentLanguage === language.code }"
        @click="changeLanguage(language.code)"
      >
        {{ language.shortLabel }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanguageSelector',
  data() {
    return {
      languages: [
        {
          code: 'vi',
          name: 'Tiếng Việt',
          shortLabel: 'VI'
        },
        {
          code: 'zh',
          name: '中文',
          shortLabel: '中文'
        }
      ]
    }
  },
  computed: {
    currentLanguage() {
      return this.$i18n.locale
    }
  },
  methods: {
    changeLanguage(languageCode) {
      this.$i18n.locale = languageCode
      localStorage.setItem('locale', languageCode)
      
      // Reload trang để đảm bảo tất cả component được cập nhật
      this.$nextTick(() => {
        window.location.reload()
      })
    }
  }
}
</script>

<style scoped>
.language-switch {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.language-switch__label {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.language-switch__track {
  display: inline-flex;
  align-items: center;
  padding: 4px;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #f8fafc;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.06);
}

.language-switch__option {
  min-width: 46px;
  height: 28px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
}

.language-switch__option--active {
  background: linear-gradient(135deg, #2563eb, #38bdf8);
  color: #ffffff;
  box-shadow: 0 6px 14px rgba(37, 99, 235, 0.28);
}
</style>
